import React from 'react';

type BadgeVariant = 'active' | 'completed' | 'on-hold' | 'archived' | 'danger' | 'info';

interface BadgeProps {
  variant: BadgeVariant;
  children: React.ReactNode;
  dot?: boolean;
  className?: string;
}

const variantMap: Record<BadgeVariant, string> = {
  active: 'badge-active',
  completed: 'badge-completed',
  'on-hold': 'badge-on-hold',
  archived: 'badge-archived',
  danger: 'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-danger/15 text-danger',
  info: 'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-primary/15 text-primary',
};

export default function Badge({ variant, children, dot = false, className = '' }: BadgeProps) {
  return (
    <span className={`${variantMap[variant]} ${className}`}>
      {dot && (
        <span
          className="w-1.5 h-1.5 rounded-full flex-shrink-0"
          style={{
            backgroundColor:
              variant === 'active' ? 'var(--active)' :
              variant === 'completed' ? 'var(--completed)' :
              variant === 'on-hold' ? 'var(--on-hold)' :
              variant === 'danger' ? 'var(--danger)' : 'var(--muted-foreground)',
          }}
        />
      )}
      {children}
    </span>
  );
}